if (!window.Eurus.loadedScript.has('preview-color-swatches.js')) {
  window.Eurus.loadedScript.add('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {          
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.checkVariantSelected();
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }));

      Alpine.data('xDoubleTouch', (productUrl) => ({
        lastTapTime: 0,
        DOUBLE_TAP_DELAY: 300,
        singleTapTimeout: null,
        touchStartX: 0,
        touchStartY: 0,
        touchMoved: false,
        MAX_MOVE_THRESHOLD: 10,
        showSecond: false,
        touchEndX: 0, /* [mobile-swipe] track end position for swipe detection */

        onTouchStart(event) {
          const touch = event.touches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.touchEndX = touch.clientX; /* [mobile-swipe] initialize end to start */
          this.touchMoved = false;
        },

        onTouchMove(event) {
          const touch = event.touches[0];
          this.touchEndX = touch.clientX; /* [mobile-swipe] update end position */
          const deltaX = Math.abs(touch.clientX - this.touchStartX);
          const deltaY = Math.abs(touch.clientY - this.touchStartY);
          if (deltaX > this.MAX_MOVE_THRESHOLD || deltaY > this.MAX_MOVE_THRESHOLD) {
            this.touchMoved = true;
          }
        },

        onTouchEnd(splide, carousel) {
          /* [mobile-swipe] horizontal swipe toggles second image
             To rollback: remove this block and uncomment the original below */
          if (this.touchMoved) {
            /* When the card carries an image slider, Splide owns horizontal
               swipes. Toggling showSecond here consumed the gesture, so the
               slider never moved — and the second-image layer it reveals is
               only rendered in hover mode, so the card went blank instead. */
            if (this.$el?.closest?.('.card-product')?.querySelector('.x-splide')) return;
            const swipeX = Math.abs(this.touchEndX - this.touchStartX);
            const swipeY = Math.abs(this.touchStartY - (event.changedTouches?.[0]?.clientY ?? this.touchStartY));
            if (swipeX > 30 && swipeX > swipeY) {
              this.showSecond = !this.showSecond;
            }
            return;
          }
          /* [mobile-swipe] original code:
          if (this.touchMoved) {
            return;
          }
          */
  
          const currentTime = new Date().getTime();
          const tapLength = currentTime - this.lastTapTime;
  
          if (tapLength < this.DOUBLE_TAP_DELAY && tapLength > 0) {
            clearTimeout(this.singleTapTimeout);
            this.lastTapTime = 0;
            this.onDoubleTap(splide, carousel);
          } else {
            this.lastTapTime = currentTime;
            this.singleTapTimeout = setTimeout(() => {
              this.onSingleTap();
            }, this.DOUBLE_TAP_DELAY);
          }
        },
  
        onSingleTap() {
          window.location.href= productUrl
        },
  
        onDoubleTap(splide, carousel) {
          if (carousel) {
            Alpine.store('xSplide').togglePlayPause(splide)
          } else {
            this.showSecond = !this.showSecond;
          }
        }
      }));

      Alpine.store('xPreviewColorSwatch', {
        onChangeVariant(el, productUrl, src, variantId, sectionId, isColor = false) {
          setTimeout(() => {
            document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
              if (e.detail.currentVariant == null) {
                this.updateImage(el, productUrl, src, variantId, sectionId);
              }
            });

            if (!isColor) {
              let productVariants = ''

              document.dispatchEvent(new CustomEvent(`eurus:product-variant-get:${sectionId}`, {
                detail: {
                  callback: (variants) => {
                    productVariants = variants;
                  }
                }
              }));

              if (productVariants) {
                let variantSrc = productVariants.reduce((acc, variant) => {
                  if (variant.featured_image) {
                    acc[variant.id] = variant.featured_image.src;
                  }
                  return acc;
                }, {});
        
                const swatchesContainer = el.closest('.options-container');
                if (swatchesContainer) {
                  const swatches = swatchesContainer.querySelectorAll('label.color-watches');
                  const inputs = swatchesContainer.querySelectorAll('input:checked');
      
                  let selectedOption = [];
      
                  inputs.forEach(input => { 
                    if (![...swatches].some(swatch => swatch.dataset.optionvalue === input.value)) {
                      selectedOption.push(input.value.replace(/\\u003c/g, '<').replace(/\\u003e/g, '>'));
                    }
                  });
      
                  let imageSrc = productVariants
                    .filter(variant => selectedOption.every(option => variant.options.includes(option)))
                    .reduce((acc, variant) => {
                      swatches.forEach((swatch) => {
                        if (variant.options.includes(swatch.getAttribute('data-optionvalue'))) {
                          acc[swatch.getAttribute('data-optionvalue')] =  `url(${variantSrc[variant.id] ? variantSrc[variant.id] : src})`
                        }
                      });
                      return acc;
                    }, {});
                  swatches.forEach((swatch) => {
                    swatch.style.setProperty('--bg-image',  imageSrc[swatch.getAttribute('data-optionvalue')]);
                  });
                }
              }
            } 
          }, 0) // INP
        },

        updateImage(el, productUrl, src, variantId, sectionId, hasVariant) {
          const cardProduct = el.closest('.card-product');
          let getLink =  productUrl + `?variant=${variantId}`;
          if (!cardProduct) return;
          const linkVariant = cardProduct.getElementsByClassName("link-product-variant");
          for (var i = 0; i < linkVariant.length; i ++) {
            linkVariant[i].setAttribute("href", getLink);
          }
          const currentVariant = cardProduct.querySelector(".current-variant");
          if (currentVariant && !hasVariant) {
            currentVariant.innerText = variantId;
          }

          if (src != '') {
            let media = cardProduct.querySelector(`[media="${src}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide) {
                if (slide.splide) {
                  slide.splide.go(Number(index));
                } else {
                  document.addEventListener(`eurus:${sectionId}:splide-ready`, () => {
                    slide.splide.go(Number(index));
                  });
                }
                return;
              } 
            }
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", src);
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          } else {
            let slide = cardProduct.querySelector('.x-splide');
            if (slide && slide.splide) {
              slide.splide.go(0);
            }
          }
        },
        updateQuickAdd(productUrl, variantId, quickAddPageParam, productId, el){
          return;
          let url = `${productUrl}?variant=${variantId}&section_id=choose-option&page=${quickAddPageParam}`
          fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const listCurrent = document.querySelectorAll(`#product-form-choose-option${productId}${quickAddPageParam ?? ''}`);
            const destination = html.querySelector(`#product-form-choose-option${productId}${quickAddPageParam ?? ''}`);
            if (listCurrent.length > 0 && destination) {
              listCurrent.forEach((item)=>{
                const currentPrice = item.closest('.card-product').querySelector(".main-product-price");
                const updatePrice = html.querySelector(".main-product-price");
                if(currentPrice && updatePrice){
                  currentPrice.innerHTML = updatePrice.innerHTML
                }
              })
            } else {
              if (listCurrent.length > 0) {
                listCurrent.forEach((item) => {
                  item.innerHTML = html.querySelector('.form').innerHTML;
                })
              }
              const currentPrice = el?.closest('.card-product')?.querySelector(".main-product-price");
              const updatePrice = html.querySelector(".main-product-price");
              if(currentPrice && updatePrice){
                currentPrice.innerHTML = updatePrice.innerHTML
              }
            }
          })
        }
      });
    })
  });
// Keep the shared card helpers inside the loaded-script guard: sections can
// include this asset again when they render or load additional cards.
/* The card image slider sits inside the product <a>, so a drag that ends over
   the image fires the link and navigates away mid-swipe. Splide cancels its own
   click, but the anchor is an ancestor and still gets it. Record how far the
   pointer travelled and swallow the click in the capture phase when it was a
   drag rather than a tap. */
(function () {
  var THRESHOLD = 8;
  var startX = 0, startY = 0, moved = 0;

  function down(e) {
    var p = e.touches ? e.touches[0] : e;
    startX = p.clientX; startY = p.clientY; moved = 0;
  }
  function move(e) {
    if (!startX && !startY) return;
    var p = e.touches ? e.touches[0] : e;
    var d = Math.abs(p.clientX - startX) + Math.abs(p.clientY - startY);
    if (d > moved) moved = d;
  }
  document.addEventListener('pointerdown', down, { passive: true, capture: true });
  document.addEventListener('pointermove', move, { passive: true, capture: true });
  document.addEventListener('touchstart', down, { passive: true, capture: true });
  document.addEventListener('touchmove', move, { passive: true, capture: true });

  document.addEventListener('click', function (e) {
    if (moved <= THRESHOLD) return;
    var slider = e.target.closest && e.target.closest('.x-splide');
    if (!slider) return;
    e.preventDefault();
    e.stopPropagation();
    moved = 0;
  }, true);
})();

/* Card image scrollbar — one thumb, one slide wide, driven from the slider's
   own pixel position so it travels with a drag rather than snapping between
   cells at the end of the gesture. */
(function () {
  /* Mount notifications handle sliders that are not ready on the first pass. */
  function wire(root) {
    if (!root) return true;
    var sp = root.splide;
    if (!sp) return false;
    if (root.__mioBarWired === sp) return true;
    root.__mioBarWired = sp;

    /* Splide rubber-bands past the first and last slide: its drag handler
       divides the overshoot by a friction factor rather than refusing it.
       In a card that exposes the empty track beside the image, so the image
       stops covering the card. Hold the track at its limits instead. */
    sp.on('drag dragging', function () {
      var M = sp.Components.Move;
      var a = M.getLimit(false);
      var b = M.getLimit(true);
      var lo = Math.min(a, b);
      var hi = Math.max(a, b);
      var pos = M.getPosition();
      if (pos > hi) M.translate(hi);
      else if (pos < lo) M.translate(lo);
    });

    var card = root.closest('.card-product');
    var bar = card && card.querySelector('.mio-card-scrollbar');
    if (!bar) return true;
    var thumb = bar.querySelector('.mio-card-scrollbar__thumb');
    if (!thumb) return true;

    function update() {
      var n = sp.length;
      if (!n || n < 2) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      thumb.style.width = (100 / n) + '%';
      var frac = sp.index;
      try {
        var M = sp.Components.Move;
        /* Measure against the track's own travel, not clientWidth: the two
           disagree by a subpixel, so the thumb settled at 99.7% and snap()
           then hopped it the rest a beat later. Negate rather than take the
           absolute value — position runs negative as the track advances, so
           Math.abs turned any overshoot past slide 0 into forward travel. */
        var span = Math.abs(M.getLimit(true) - M.getLimit(false));
        if (span) frac = (-M.getPosition() / span) * (n - 1);
      } catch (e) { /* fall back to the settled index */ }
      if (frac < 0) frac = 0;
      if (frac > n - 1) frac = n - 1;
      thumb.style.transform = 'translateX(' + (frac * 100) + '%)';
    }

    /* Splide animates the track to its resting place after a release, and
       emits nothing in between — so sampling only on events left the thumb
       parked mid-gesture and then jumping when 'moved' finally fired. Sample
       every frame for as long as the track is actually moving instead. */
    var raf = null, stopAt = 0;
    function snap() {
      /* Land on the exact slide. Sampling stops a frame or two before the
         transition ends, which left the thumb parked at 99.7% of the way. */
      var n = sp.length;
      if (n > 1) thumb.style.transform = 'translateX(' + (sp.index * 100) + '%)';
    }
    function tick() {
      update();
      if (Date.now() > stopAt) { raf = null; snap(); return; }
      raf = requestAnimationFrame(tick);
    }
    function follow() {
      stopAt = Date.now() + 1200;          /* safety: never spin forever */
      if (!raf) raf = requestAnimationFrame(tick);
    }
    function settle() {
      /* 'moved' means the track has finished animating, so the resting index
         is final — land on it in this frame. Letting the sampler run on for a
         few more frames parked the thumb a fraction short of the slide and
         then hopped it into place once the window expired, which read as the
         bar moving on its own after the swipe had ended. */
      stopAt = 0;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      snap();
    }

    /* 'dragged' fires on release, BEFORE the track animates to its resting
       slide. Ending the sampling window there froze the thumb a fifth of the
       way through the settle, and snap() then jumped it the rest — the two
       separate movements. Only 'moved', which fires when the animation is
       finished, may end it. */
    sp.on('drag dragging move dragged', follow);
    sp.on('moved', settle);
    sp.on('mounted refresh updated resized', update);
    update();
    return true;
  }

  /* xSplide announces each card after mounting, including cards inserted by
     Recently Viewed, pagination or the theme editor. No offscreen polling or
     whole-document mutation observer is needed. */
  document.addEventListener('mio:card-slider:ready', function (event) {
    wire(event.target);
  });

  function wireExisting() {
    document.querySelectorAll('.card-product .x-splide').forEach(wire);
  }

  // Also cover sliders mounted before this asset finished loading.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireExisting, { once: true });
  } else {
    wireExisting();
  }
})();

/* Belt and braces for the card slider: a native dragstart inside the product
   link starts iOS's link drag / preview and cancels the touch sequence, so the
   swipe dies. -webkit-user-drag covers WebKit; this covers the HTML5 drag API
   on every engine, including images the template renders outside the slide
   loop. */
document.addEventListener('dragstart', function (e) {
  if (e.target && e.target.closest && e.target.closest('.card-product .x-splide')) {
    e.preventDefault();
  }
}, true);

/* Nested sliders. A card's image slider can sit inside a row that is itself a
   slider — recently viewed, featured collection, related products. Each binds
   its own pointerdown on its own track in the capture phase, so a touch on a
   card image starts BOTH drags and which one you get is a coin toss.

   Give the gesture to whichever slider is actually under the finger: a touch on
   a card image belongs to that card, anything else in the row belongs to the
   row. These listeners sit on the document, which is above either track in the
   capture path, so the row's drag is switched off before it ever sees the
   touch, and switched back on when the finger lifts. */
(function () {
  var suspended = null;

  function rowSliderAbove(inner) {
    var n = inner.parentElement;
    while (n && n !== document.body) {
      if (n.splide && n.splide.Components && n.splide.Components.Drag) return n.splide;
      n = n.parentElement;
    }
    return null;
  }

  function release() {
    if (!suspended) return;
    var row = suspended;
    suspended = null;
    /* After the row's own pointerup handlers, so it cannot read the gesture
       on the way out. */
    setTimeout(function () { row.Components.Drag.disable(false); }, 0);
  }

  function claim(e) {
    release();
    var t = e.target;
    var inner = t && t.closest && t.closest('.card-product .x-splide');
    if (!inner || !inner.splide) return;
    var row = rowSliderAbove(inner);
    /* Only when the row is draggable to begin with — re-enabling one that its
       own breakpoint had turned off would hand back a gesture it never had. */
    if (!row || !row.options.drag) return;
    row.Components.Drag.disable(true);
    suspended = row;
  }

  document.addEventListener('touchstart', claim, { passive: true, capture: true });
  document.addEventListener('mousedown', claim, { passive: true, capture: true });
  ['touchend', 'touchcancel', 'mouseup'].forEach(function (type) {
    document.addEventListener(type, release, { passive: true, capture: true });
  });
})();
}
